<template>
	<div :class="specifyClassName">
		<h4>
			{{ h4Name }}
			<a class="more" :href="'/mag/' + categoryName">more stories/ 閱讀更多</a>
		</h4>
		<slick
			ref="slick"
			:options="allOptions"
			@afterChange="handleAfterChange"
			@beforeChange="handleBeforeChange"
			@breakpoint="handleBreakpoint"
			@destroy="handleDestroy"
			@edge="handleEdge"
			@init="handleInit"
			@reInit="handleReInit"
			@setPosition="handleSetPosition"
			@swipe="handleSwipe"
			@lazyLoaded="handleLazyLoaded"
			@lazyLoadError="handleLazeLoadError"
		>
			<div v-for="item in list" :key="item.ID">
				<a :href="'/mag/article/' + item.ID">
					<div class="mag-cover" :style="{ backgroundImage: 'url(' + item.CoverImage + ')' }"></div>
					<div class="mag-list-info">
						<span class="post-time">{{ dateFormate(item.PostTime) }}</span>
						<h3>{{ item.Title }}</h3>
					</div>
				</a>
			</div>
		</slick>
	</div>
</template>

<script>
import Slick from "@global/vendors/vue-slick";
import { dateFormate } from "@global/components/blog/ArticleTools";
import AlertDialog from "@global/helpers/alertDialog";

export default {
	name: "ArticleSlick",
	components: { Slick },
	props: {
		specifyClassName: {
			type: String,
		},
		h4Name: {
			type: String,
		},
		NowMyEquipment: {
			type: Boolean,
		},
		categoryName: {
			type: String,
		},
	},
	created() {
		let self = this;

		$.ajax({
			type: "GET",
			url: API_URL.ARTICLE_LIST,
			data: { Category: self.categoryName },
			dataType: "json",
			xhrFields: {
				withCredentials: true,
			},
			error: function () {
				console.log("error");
			},
			success: function (res) {
				if (res.Code === 200) {
					self.list = res.Response.Data;
				} else {
					AlertDialog.alert("系統忙線中,請稍後再試", function () {
						window.location.href = "/";
					});
				}
			},
		});
	},
	data() {
		return {
			list: [],
			allOptions: {
				arrows: false,
				slidesToShow: 4,
				responsive: [
					{
						breakpoint: 600,
						settings: {
							slidesToShow: 2,
							slidesToScroll: 2,
						},
					},
				],
			},
		};
	},
	methods: {
		dateFormate(PostTime) {
			return dateFormate(PostTime);
		},
		handleAfterChange(event, slick, currentSlide) {},
		handleBeforeChange(event, slick, currentSlide, nextSlide) {},
		handleBreakpoint(event, slick, breakpoint) {},
		handleDestroy(event, slick) {},
		handleEdge(event, slick, direction) {},
		handleInit(event, slick) {},
		handleReInit(event, slick) {},
		handleSetPosition(event, slick) {},
		handleSwipe(event, slick, direction) {},
		handleLazyLoaded(event, slick, image, imageSource) {},
		handleLazeLoadError(event, slick, image, imageSource) {},
	},

	beforeUpdate() {
		if (this.$refs.slick) {
			this.$refs.slick.destroy();
		}
	},
	updated() {
		this.$nextTick(function () {
			if (this.$refs.slick) {
				this.$refs.slick.create(this.allOptions);
			}
		});
	},
};
</script>

<style></style>
